const fish = [
  { kanji: "鮫", yomi: "さめ" },
  { kanji: "海鷂魚", yomi: "えい" },
  { kanji: "鯨", yomi: "くじら" },
  { kanji: "烏賊", yomi: "いか" },
  { kanji: "蛸", yomi: "たこ" },
  { kanji: "鰰", yomi: "うたうた" },
  { kanji: "蜆", yomi: "しじみ" },
  { kanji: "鯱", yomi: "しゃちほこ" },
  { kanji: "海鰻", yomi: "あなご" },
  { kanji: "鰻", yomi: "うなぎ" },
  { kanji: "糠蝦", yomi: "あみ" },
  { kanji: "鮟鱇", yomi: "あんこう" },
  { kanji: "鰯", yomi: "いわし" },
  { kanji: "海老", yomi: "えび" },
  { kanji: "牡蠣", yomi: "かき" },
  { kanji: "鰹", yomi: "かつお" },
  { kanji: "蟹", yomi: "かに" },
  { kanji: "鼠頭魚", yomi: "きす" },
  { kanji: "細螺", yomi: "きさご" },
  { kanji: "海月", yomi: "くらげ" },
  { kanji: "鯉", yomi: "こい" },
  { kanji: "鮭", yomi: "さけ" },
  { kanji: "鮗", yomi: "このしろ" },
  { kanji: "鰆", yomi: "さわら" },
  { kanji: "柳葉魚", yomi: "ししゃも" },
  { kanji: "青竜蝦", yomi: "しゃこ" },
  { kanji: "鱸", yomi: "すずき" },
  { kanji: "大口魚", yomi: "たら" },
  { kanji: "鱘魚", yomi: "ちょうざめ" },
  { kanji: "鰌", yomi: "どじょう" },
  { kanji: "鯰", yomi: "なまず" },
  { kanji: "鯊", yomi: "はぜ" },
  { kanji: "鱧", yomi: "はも" },
  { kanji: "鰒", yomi: "ふぐ" },
  { kanji: "鱒", yomi: "ます" },
  { kanji: "鮪", yomi: "まぐろ" },
  { kanji: "鰡", yomi: "ぼら" },
];
export { fish };
